import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Time = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41211 10.4626C6.37069 10.4626 6.33711 10.4962 6.33711 10.5376V11.8126C6.33711 11.854 6.37069 11.8876 6.41211 11.8876H9.33711C9.37853 11.8876 9.41211 11.854 9.41211 11.8126V10.5376C9.41211 10.4962 9.37853 10.4626 9.33711 10.4626H6.41211Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M10.5371 10.4626C10.4957 10.4626 10.4621 10.4962 10.4621 10.5376V11.8126C10.4621 11.854 10.4957 11.8876 10.5371 11.8876H13.4621C13.5035 11.8876 13.5371 11.854 13.5371 11.8126V10.5376C13.5371 10.4962 13.5035 10.4626 13.4621 10.4626H10.5371Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M14.6621 10.4626C14.6207 10.4626 14.5871 10.4962 14.5871 10.5376V11.8126C14.5871 11.854 14.6207 11.8876 14.6621 11.8876H17.5871C17.6285 11.8876 17.6621 11.854 17.6621 11.8126V10.5376C17.6621 10.4962 17.6285 10.4626 17.5871 10.4626H14.6621Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M6.41211 13.3501C6.37069 13.3501 6.33711 13.3837 6.33711 13.4251V14.7001C6.33711 14.7415 6.37069 14.7751 6.41211 14.7751H9.33711C9.37853 14.7751 9.41211 14.7415 9.41211 14.7001V13.4251C9.41211 13.3837 9.37853 13.3501 9.33711 13.3501H6.41211Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M10.5371 13.3501C10.4957 13.3501 10.4621 13.3837 10.4621 13.4251V14.7001C10.4621 14.7415 10.4957 14.7751 10.5371 14.7751H13.4621C13.5035 14.7751 13.5371 14.7415 13.5371 14.7001V13.4251C13.5371 13.3837 13.5035 13.3501 13.4621 13.3501H10.5371Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M14.6621 13.3501C14.6207 13.3501 14.5871 13.3837 14.5871 13.4251V14.7001C14.5871 14.7415 14.6207 14.7751 14.6621 14.7751H17.5871C17.6285 14.7751 17.6621 14.7415 17.6621 14.7001V13.4251C17.6621 13.3837 17.6285 13.3501 17.5871 13.3501H14.6621Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M6.41211 16.2376C6.37069 16.2376 6.33711 16.2712 6.33711 16.3126V17.5876C6.33711 17.629 6.37069 17.6626 6.41211 17.6626H9.33711C9.37853 17.6626 9.41211 17.629 9.41211 17.5876V16.3126C9.41211 16.2712 9.37853 16.2376 9.33711 16.2376H6.41211Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M10.5371 16.2376C10.4957 16.2376 10.4621 16.2712 10.4621 16.3126V17.5876C10.4621 17.629 10.4957 17.6626 10.5371 17.6626H13.4621C13.5035 17.6626 13.5371 17.629 13.5371 17.5876V16.3126C13.5371 16.2712 13.5035 16.2376 13.4621 16.2376H10.5371Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M14.6621 16.2376C14.6207 16.2376 14.5871 16.2712 14.5871 16.3126V17.5876C14.5871 17.629 14.6207 17.6626 14.6621 17.6626H17.5871C17.6285 17.6626 17.6621 17.629 17.6621 17.5876V16.3126C17.6621 16.2712 17.6285 16.2376 17.5871 16.2376H14.6621Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9621 4.5751C20.9621 3.72596 20.2737 3.0376 19.4246 3.0376H4.57461C3.72547 3.0376 3.03711 3.72596 3.03711 4.5751V19.4251C3.03711 20.2742 3.72547 20.9626 4.57461 20.9626H19.4246C20.2737 20.9626 20.9621 20.2742 20.9621 19.4251V4.5751ZM4.46211 4.5751C4.46211 4.51297 4.51248 4.4626 4.57461 4.4626H19.4246C19.4867 4.4626 19.5371 4.51297 19.5371 4.5751V7.1626H4.46211V4.5751ZM4.57461 19.5376C4.51248 19.5376 4.46211 19.4872 4.46211 19.4251V8.5876H19.5371V19.4251C19.5371 19.4872 19.4867 19.5376 19.4246 19.5376H4.57461Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
    </svg>
  );
};

export default Time;
